import { Link } from 'react-router-dom';
import { Mail, Linkedin, Twitter } from 'lucide-react';

const FOOTER_LOGO = 'https://customer-assets.emergentagent.com/job_f466fe8f-893f-4f54-b8ca-9e89d1419b73/artifacts/uljoibjp_STEM%20Jectory_Logo_VECTOR_2-5.png';

const footerLinks = [
  { path: '/', label: 'Home' },
  { path: '/courses', label: 'Courses' },
  { path: '/consulting', label: 'Consulting' },
  { path: '/events', label: 'Events' },
  { path: '/blog', label: 'Blog' },
  { path: '/login', label: 'Login' },
];

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brand-blue text-white" data-testid="main-footer">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <div className="mb-6">
              <img src={FOOTER_LOGO} alt="STEMJECTORY" className="h-14 w-auto" />
            </div>
            <p className="text-gray-300 mb-6 max-w-md leading-relaxed">
              Guiding students and professionals in STEAM fields to design non-linear careers 
              with purpose, wellness, and balance.
            </p>
            <p className="text-brand-lime font-accent text-sm font-medium">
              Your Path to a Limitless Future.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {footerLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-brand-turquoise transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="font-heading font-bold text-lg mb-6">Connect</h4>
            <div className="flex gap-4 mb-6">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-turquoise transition-colors"
                data-testid="social-linkedin"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-turquoise transition-colors"
                data-testid="social-twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a
                href="mailto:hello@stemjectory.com"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-turquoise transition-colors"
                data-testid="social-email"
              >
                <Mail className="w-5 h-5" />
              </a>
            </div>
            <p className="text-gray-400 text-sm">
              hello@stemjectory.com
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            &copy; {currentYear} STEMJECTORY. All rights reserved.
          </p>
          <p className="text-gray-500 text-sm">
            Designed with care for STEAM professionals everywhere.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
